export const getDefaultStats = ()=> ({
  disk: 2,
  cpu: 1,
  memory: 1
})


export const getGuideConfig =() =>({
  'entry': {
    heading: "Need help choosing the right resources?",
    description: "We get that it might be hard knowing which resources to pick. We'll take you through this quick questionnaire to hopefully determine what how much of what resource you should select.",
    icon: 'search',
    options: [{
      label: "Start Now",
      step: "visitor"
    }]
  },
  'visitor':{
    heading: "How many visitors do you expect per day?",
    options: [{
      label: "< 1,000",
      stats: {
        memory : 0
      },
      step: "online-store"
    },{
      label: "1,000-5,000",
      stats: {
        memory : 1
      },
      step: "online-store"
    },{
      label: "5,000-10,000",
      stats: {
        memory : 2
      },
      step: "online-store"
    },{
      label: "10,000+",
      stats: {
        memory : 3
      },
      step: "online-store"
    },{
      label: "Not Sure",
      stats: {
        help : 1
      },
      step: "online-store"
    }]
  },
  'online-store':{
    heading: 'Does your website have an online store',
    options: [{
      label: "Yes",
      step: "cms"
    },{
      label: "No",
      step: "storage"
    }]
  },
  'cms':{
    heading: 'What CMS does it run on?',
    options: [{
      label: "WooCommerce",
      stats: {
        cpu: 1,
        memory: 2
      },
      step: "product"
    },{
      label: "Magento",
      stats: {
        cpu: 2,
        memory: 1
      },
      step: "product"
    },{
      label: "Other",
      stats: {
        cpu: 1,
        memory: 1
      },
      step: "product"
    }]
  },
  'product':{
    heading: 'How many products?',
    options: [{
      label: "< 500",
      stats: {
        disk: 0,
      },
      step: "result"
    },{
      label: "500-1,000",
      stats: {
        disk: 1
      },
      step: "result"
    },{
      label: "1,000-2,000",
      stats: {
        disk: 2
      },
      step: "result"
    },{
      label: "2,000+",
      stats: {
        disk: 4
      },
      step: "result"
    }]
  },
  "storage":{
    heading: "What type of website do you intend to manage?",
    options: [{
      label: "Basic Information Website",
      stats: {
        disk: 0
      },
      step: "result"
    },{
      label: "Personal Blog Site",
      stats: {
        disk: 1
      },
      step: "result"
    },{
      label: "Portfolio / Gallery Website",
      stats: {
        disk: 3
      },
      step: "result"
    },{
      label: "eCommerce / Online Store",
      stats: {
        disk: 5
      },
      step: "result"
    },{
      label: "Not sure yet",
      stats: {
        disk: 0,
        help: 1
      },
      step: "result"
    }],
    longOption: true,
    startOver: true
  },
  "result":{
    heading: "Based on your answers we recommend the following combinations of resources",
    showResult: true,
    options: [{
      label: "Select these resources",
      step: "entry"
    }],
    longOption: true,
    startOver: true
  },
  "help":{
    heading: "Not too sure about your website's specifications?  We encourage you to have a chat to our Sales team.",
    showContact: true,
    startOver: true
  }
})
